import React from "react";
import { useState } from "react";
import {
  BiArrowBack,
  BiCheck,
  BiLockAlt,
  BiMailSend,
  BiPhone,
  BiUpload,
  BiUser,
  BiX,
} from "react-icons/bi";
import "./login.scss";
import { GoogleOAuthProvider } from "@react-oauth/google";
import "../../scss/main.scss";
import { useEffect } from "react";
import { iconStyle } from "../../utils/generalUtils";
import { calls } from "../../config/db_config";
import { tokenToCookie } from "../../utils/token-to-cookie";
import { logUtils } from "../../utils/logUtils";
import GoogleAuth from "./googleAuth";
import AppleAuth from "./appleAuth";
import { FaApple } from "react-icons/fa";
import TermsAndConditions from "./termsAndConditions";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { setHasCameraAccess } from "../../components/Navbar/navbarSlice";
import { cookieUtils } from "../../utils/cookie-parser";
import Compress from "compress.js";
import ExamThumbnail from "../../components/ExamThumbnail/exam-thumbnail";
import { fileUtils } from "../../utils/fileUtils";
import { nanoid } from "nanoid";
import axios from "axios";

const Login = () => {
  const hasCameraAccess = useSelector((state) => state.profile.hasCameraAccess);
  const index = 0;
  const [submitFiles, setSubmitFiles] = useState([]);
  const [thumbnails, setThumbnails] = useState([]);
  const compress = new Compress();
  const [answerText, setAnswerText] = useState("");
  const envVars = useSelector((state) => state.profile.environmentVars);
  const [isRegister, setIsRegister] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const [showProtection, setShowProtection] = useState(false);
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [hasRegister, setHasRegister] = useState(false);
  const [openForgot, setOpenForgot] = useState(false);
  const [logoLink, setLogoLink] = useState("");

  useEffect(() => {
    document.body.style.height = "100vh";
    document.body.style.overflow = "hidden";
    getEnvironment();
    getSettingValue();
  }, []);

  useEffect(() => {
    if (window.location.pathname === "/register") {
      setIsRegister(true);
    } else {
      setIsRegister(false);
    }
  }, [window.location.pathname]);

  useEffect(() => {
    const isRunningInWebView = () => {
      return window.ReactNativeWebView !== undefined;
    };
    if (isRunningInWebView()) {
      cookieUtils.deleteSpecificCookies();
    }
  }, []);

  useEffect(() => {
    const handleIncomingMessage = (eventData) => {
      let data;
      try {
        data = JSON.parse(eventData);
        if (data.message) {
          switch (data.message) {
            case "GOOGLE_LOGIN":
              if (data.data) {
                googleLogin(data.data);
              }
              break;
            default:
              break;
          }
        }
      } catch (e) {
        // Handle JSON parsing error
      }
    };

    const setupMessageListener = () => {
      const isAndroid = /Android/i.test(navigator.userAgent);
      if (isAndroid) {
        document.addEventListener("message", (event) => {
          handleIncomingMessage(event.data);
        });
      } else {
        window.addEventListener("message", (event) => {
          handleIncomingMessage(event.data);
        });
      }
    };

    // Call setupMessageListener to setup the appropriate listener
    setupMessageListener();

    // Cleanup function to remove event listener
    return () => {
      if (/Android/i.test(navigator.userAgent)) {
        document.removeEventListener("message", handleIncomingMessage);
      } else {
        window.removeEventListener("message", handleIncomingMessage);
      }
    };
  }, []);

  const imageChange = async (event) => {
    let fileList = Array.from(event.target.files);

    const imageList = fileList.filter(
      (file) => file.type !== "application/pdf"
    );
    const pdfList = fileList.filter((file) => file.type === "application/pdf");

    let tempThumbnailList = [];

    let updatedFileList = submitFiles;
    updatedFileList[index] = [];

    await compress
      .compress(imageList, {
        size: 2, // the max size in MB, defaults to 2MB
        quality: 0.75, // the quality of the image, max is 1,
        maxWidth: 1920, // the max width of the output image, defaults to 1920px
        maxHeight: 1920, // the max height of the output image, defaults to 1920px
        resize: true, // defaults to true, set false if you do not want to resize the image width and height
        rotate: false, // See the rotation section below
      })
      .then((data) => {
        data.forEach(function (singleData) {
          const base64 = singleData.data;
          const name = singleData.alt;
          const imgExt = singleData.ext;

          const blob = Compress.convertBase64ToFile(base64, imgExt);

          // let mFile = dataURLToFile(base64, name);
          let file = new File([blob], name);
          updatedFileList[index].push(file);

          let baseData = "data:" + imgExt + ";base64," + base64;
          tempThumbnailList.push(baseData);
        });
      });
    // set thumbnails (base64 inside)
    setThumbnails(tempThumbnailList);

    updatedFileList.push(pdfList);
    // set files (file types inside)
    setSubmitFiles(updatedFileList);
  };

  const populateThumbnails = () => {
    return thumbnails.map((image, i) => {
      return (
        <ExamThumbnail
          key={i}
          index={i}
          removeThumbnail={removeThumbnail}
          image={image}
        />
      );
    });
  };

  const removeThumbnail = (i) => {
    let updatedFileList = submitFiles;
    let tempThumbnails = thumbnails;

    if (thumbnails.length >= 1) {
      updatedFileList[index].splice(i, 1);
      tempThumbnails.splice(i, 1);
    } else {
      updatedFileList[index] = [];
      tempThumbnails = [];
    }

    setThumbnails(Array.from(tempThumbnails));
    setSubmitFiles(updatedFileList);
  };

  const getEnvironment = () => {
    fetch(calls.getLogoLink, {
      method: "get",
      headers: {
        "Content-Type": "application/json",
        // Authorization: tokenUtils.getBearerToken(),
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          setLogoLink(data.data);
        }
      });
  };

  const getSettingValue = () => {
    let args = "?setting_name=has_register";
    fetch(calls.getSettingValue + args, {
      method: "get",
      headers: {
        "Content-Type": "application/json",
        // Authorization: tokenUtils.getBearerToken(),
      },
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(" setting value ");
        console.log(data);
        if (data.status === 200) {
          if (data.data && data.data[0] && data.data[0].value) {
            setHasRegister(true);
          }
        } else {
          setHasRegister(false);
        }
      });
  };

  const [loginEmail, setLoginEmail] = useState("");
  const [forgotEmail, setForgotEmail] = useState("");
  const [loginPwd, setLoginPwd] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  const [showSuccess, setShowSuccess] = useState(false);

  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [pwd, setPwd] = useState("");
  const [repeatPwd, setRepeatPwd] = useState("");

  useEffect(() => {
    setErrorMsg("");
  }, [isRegister]);

  const returnHomeNative = () => {
    if (isRunningInWebView && window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          type: "RETURN_HOME",
        })
      );
    }
  };

  const isRunningInWebView = () => {
    return window.ReactNativeWebView !== undefined;
  };

  const dispatch = useDispatch();

  const search = useLocation().search;
  const searchParams = new URLSearchParams(search);
  const paramAllowCameraAccess = searchParams.get("hasCameraAccess");
  if (paramAllowCameraAccess) {
    dispatch(setHasCameraAccess(parseInt(paramAllowCameraAccess)));
  }

  const login = (event) => {
    if (event) {
      event.preventDefault();
    }
    setShowSuccess(false);
    if (!loginEmail) {
      setErrorMsg("Παρακαλώ εισάγετε email");
    } else if (!loginPwd) {
      setErrorMsg("Παρακαλώ εισάγετε κωδικό");
    } else {
      setIsLoading(true);
      const data = {
        email: loginEmail,
        password: loginPwd,
      };
      fetch(calls.signIn, {
        method: "post",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status != null && data.status === 200) {
            tokenToCookie(data.user);
            logUtils.loggedIn().then((r) => {
              if (isRunningInWebView && window.ReactNativeWebView) {
                const schools = data.schools
                  ? data.schools.filter(
                    (item) => item.school_url !== process.env.domain
                  )
                  : [];
                const schoolsToSend = [];
                schools.map((school) => {
                  schoolsToSend.push({
                    schoolName: school.school_name,
                    schoolLogo: school.school_logo,
                    schoolDomain: school.school_url,
                  });
                });
                window.ReactNativeWebView.postMessage(
                  JSON.stringify({
                    type: "USER_SCHOOL_INFO",
                    data: schoolsToSend,
                  })
                );
                window.ReactNativeWebView.postMessage(
                  JSON.stringify({
                    type: "LOGGED_IN",
                    userData: {
                      email: loginEmail,
                    },
                    token: data.user.token,
                    user_id: data.user.user_id,
                  })
                );
              }
              window.location.href = "/";
            });
          } else {
            if (data.message) {
              setIsLoading(false);
              if (data.message == "wrong-pwd") {
                setErrorMsg("Λάθος κωδικός");
              } else if (data.message == "user-not-found") {
                setErrorMsg("Ο χρήστης με αυτό το email δε βρέθηκε");
              } else if (data.message == "not-activated") {
                setErrorMsg(
                  "Ο λογαριασμός σας δεν έχει ενεργοποιήθει ακομά. Θα ειδοποιηθείτε μέσω email όταν κάποιος υπέυθυνος ενεργοποιήσει τον λογαριασμό σας."
                );
              }
            } else {
              setIsLoading(false);
              setErrorMsg("Υπήρχε κάποιο πρόβλημα στην σύνδεση σας");
            }
          }
        });
    }
  };

  const registerFiles = (event) => {
    event.preventDefault();

    // 1) short-circuit if no files
    if (!submitFiles.length || !submitFiles.some((arr) => arr.length)) {
      return register(event, []);
    }

    // 2) build FormData exactly like your working example
    const formData = new FormData();
    const submissionLinks = [];
    let i = 0;

    submitFiles.forEach((filesArray) => {
      if (!filesArray.length) return;
      submissionLinks.push([]);
      let j = 0;

      filesArray.forEach((image) => {
        // clone the Blob so we can rename it
        const blob = image.slice(0, image.size, image.type);
        const ext = fileUtils.getFileExtension(image.name);
        const newName = `curriculum-answer-${i}-${j++}-${nanoid()}.${ext}`;
        const newFile = new File([blob], newName, { type: image.type });

        submissionLinks[i].push(newName);

        console.log("Appending to FormData:", newFile);
        formData.append("arrayOfFilesName", newFile);
      });

      i++;
    });

    // 3) dump out every entry so you can verify it’s not actually empty
    for (let [key, val] of formData.entries()) {
      console.log("FormData entry:", key, val);
    }

    // 4) fire off the upload with axios (no manually set Content-Type)
    axios
      .post(calls.submitCurriculumAnswersImages, formData)
      .then((response) => {
        console.log("Upload response:", response);
        // on success, proceed with your register flow
        register(event, submissionLinks);
        // setSubmitFiles([]);
        // setThumbnails([]);
      })
      .catch((err) => {
        console.error("Upload failed:", err);
        setErrorMsg("Απέτυχε η αποστολή των αρχείων. Δοκιμάστε ξανά.");
      });
  };

  const register = (event, submissionLinks) => {
    if (event) {
      event.preventDefault();
    }

    if (!firstName) {
      setErrorMsg("Παρακαλώ εισάγετε όνομα");
    } else if (!lastName) {
      setErrorMsg("Παρακαλώ εισάγετε επώνυμο");
    } else if (!email) {
      setErrorMsg("Παρακαλώ εισάγετε email");
    } else if (!pwd) {
      setErrorMsg("Παρακαλώ εισάγετε κωδικό");
    } else if (!repeatPwd) {
      setErrorMsg("Παρακαλώ εισάγετε ξανά τον κωδικό");
    } else if (!(/[A-Za-zΑ-Ωα-ω]/.test(pwd) && /\d/.test(pwd))) {
      setErrorMsg(
        "Ο κωδικός σας πρέπει να περίεχει τουλάχιστον ένα γράμμα και έναν αριθμό."
      );
    } else if (pwd.length < 6) {
      setErrorMsg("Ο κωδικός σας πρέπει να περιέχει τουλάχιστον 6 χαρακτήρες.");
    } else if (pwd != repeatPwd) {
      setErrorMsg("Οι κωδικοί σας δε ταιριάζουν");
    } else if (!acceptTerms) {
      setErrorMsg(
        "Η εγγραφή δε μπορεί να γίνει χωρίς την αποδοχή όρων χρήσης και πολιτικής προστασίας"
      );
    } else {
      // everything in the form is correct
      setIsLoading(true);
      // TODO: consider a datepicker or initialize a default value
      const d = new Date();
      d.setTime(d.getTime() - 27 * 365 * 24 * 60 * 60 * 1000);
      const birthday = new Date().toISOString().slice(0, 19).replace("T", " ");

      // TODO: get user_type from secret_code
      const data = {
        email: email,
        password: pwd,
        first_name: firstName,
        last_name: lastName,
        phone: phone,
        submission_links: submissionLinks
          ? JSON.stringify(submissionLinks)
          : "",
        general_comments: answerText,
      };

      fetch(calls.signUp, {
        method: "post",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.message) {
            if (data.message == "register-success") {
              setShowSuccess(true);
              setIsRegister(false);
              setErrorMsg("");
              setEmail("");
              setFirstName("");
              setPwd("");
              setRepeatPwd("");
              setLastName("");
              setIsLoading(false);
              setSubmitFiles([]);
              setThumbnails([]);
            } else {
              setIsLoading(false);
              setErrorMsg(data.message);
            }
          }
        });
    }
  };

  const googleLogin = (credentialResponse) => {
    try {
      const googleData = JSON.parse(credentialResponse);
      const data = {
        is_google: true,
        first_name: googleData.given_name,
        last_name: googleData.family_name,
        profile_picture: googleData.picture,
        email: googleData.email,
        google_id: googleData.sub,
      };

      fetch(calls.googleLogin, {
        method: "post",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
        .then((response) => response.json())
        .then((data) => {
          if (
            data.status != null &&
            data.status === 200 &&
            data.message != "register-success"
          ) {
            tokenToCookie(data.user);
            if (isRunningInWebView && window.ReactNativeWebView) {
              const schools = data.schools
                ? data.schools.filter(
                  (item) => item.school_url !== process.env.domain
                )
                : [];
              const schoolsToSend = [];
              schools.map((school) => {
                schoolsToSend.push({
                  schoolName: school.school_name,
                  schoolLogo: school.school_logo,
                  schoolDomain: school.school_url,
                });
              });
              window.ReactNativeWebView.postMessage(
                JSON.stringify({
                  type: "USER_SCHOOL_INFO",
                  data: schoolsToSend,
                })
              );
              window.ReactNativeWebView.postMessage(
                JSON.stringify({
                  type: "LOGGED_IN",
                  userData: {
                    email: loginEmail,
                  },
                  token: data.user.token,
                  user_id: data.user.user_id,
                })
              );
            }
            window.location.href = "/";
          } else if (data.message) {
            if (data.message == "register-success") {
              setShowSuccess(true);
              setIsRegister(false);
              setErrorMsg("");
              setEmail("");
              setFirstName("");
              setPwd("");
              setRepeatPwd("");
              setLastName("");
              setIsLoading(false);
            } else if (data.message == "user-exists") {
              setErrorMsg("Υπάρχει ήδη χρήστης με αυτό το email");
            } else {
              if (data.message == "not-activated") {
                setIsLoading(false);
                setErrorMsg(
                  "Ο λογαριασμός σας δεν έχει ενεργοποιήθει ακομά. Θα ειδοποιηθείτε μέσω email όταν κάποιος υπέυθυνος ενεργοποιήσει τον λογαριασμό σας."
                );
              } else {
                setIsLoading(false);
                setErrorMsg(data.message);
              }
            }
          } else {
            setIsLoading(false);
            setErrorMsg("Υπήρχε κάποιο πρόβλημα στη σύνδεση.");
          }
        });
    } catch (e) {
      console.log(e);
    }
  };

  const appleLogin = (appleResponse) => {
    try {
      const res =
        typeof appleResponse === "string"
          ? JSON.parse(appleResponse)
          : appleResponse;

      const { authorization = {}, user } = res || {};
      const payload = {
        id_token: authorization?.id_token, // required by your backend
        code: authorization?.code, // optional (future exchange)
        email: user?.email ?? null, // Apple may only send once
        first_name: user?.name?.firstName ?? "",
        last_name: user?.name?.lastName ?? "",
      };

      if (!payload.id_token) {
        console.error("No id_token from Apple. Check response_type.");
        setErrorMsg("Δεν λάβαμε id_token από την Apple. Ξαναδοκίμασε.");
        return;
      }

      fetch(calls.appleLogin, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      })
        .then((r) => r.json())
        .then((data) => {
          if (data?.status === 200 && data?.message !== "register-success") {
            tokenToCookie(data.user);

            if (isRunningInWebView && window.ReactNativeWebView) {
              const schools = data.schools
                ? data.schools.filter(
                  (item) => item.school_url !== process.env.domain
                )
                : [];
              const schoolsToSend = schools.map((s) => ({
                schoolName: s.school_name,
                schoolLogo: s.school_logo,
                schoolDomain: s.school_url,
              }));
              window.ReactNativeWebView.postMessage(
                JSON.stringify({
                  type: "USER_SCHOOL_INFO",
                  data: schoolsToSend,
                })
              );
              window.ReactNativeWebView.postMessage(
                JSON.stringify({
                  type: "LOGGED_IN",
                  userData: { email: data?.user?.email },
                  token: data.user.token,
                  user_id: data.user.user_id,
                })
              );
            }

            window.location.href = "/";
          } else if (data?.message === "register-success") {
            setShowSuccess(true);
            setIsRegister(false);
            setErrorMsg("");
            setEmail("");
            setFirstName("");
            setPwd("");
            setRepeatPwd("");
            setLastName("");
            setIsLoading(false);
          } else if (data?.message === "no-email") {
            setErrorMsg(
              "Το Apple δεν έδωσε email. Επίλεξε κοινοποίηση email και ξαναπροσπάθησε."
            );
          } else if (data?.message === "user-exists") {
            setErrorMsg("Υπάρχει ήδη χρήστης με αυτό το email");
          } else if (data?.message === "not-activated") {
            setErrorMsg("Ο λογαριασμός σας δεν έχει ενεργοποιηθεί ακόμα.");
          } else {
            setErrorMsg("Υπήρχε κάποιο πρόβλημα στη σύνδεση.");
          }
        })
        .catch((e) => {
          console.error(e);
          setErrorMsg("Υπήρχε κάποιο πρόβλημα στη σύνδεση.");
        });
    } catch (e) {
      console.error(e);
      setErrorMsg("Αποτυχία Apple σύνδεσης.");
    }
  };

  const handleApplePress = () => {
    if (isRunningInWebView() && window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({ type: "APPLE_LOGIN" })
      );
    } else if (window.appleStartSignIn) {
      window.appleStartSignIn();
    } else {
      console.warn("Apple JS not ready yet.");
    }
  };

  const handleGooglePress = () => {
    if (isRunningInWebView && window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          type: "GOOGLE_LOGIN",
        })
      );
    }
  };

  const forgotPassword = () => {
    const data = {
      email: forgotEmail,
    };

    fetch(calls.forgotPassword, {
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(" forgot call ");
        console.log(data);
      });
  };

  return (
    <div
      className={
        "start-page " +
        (isRunningInWebView && window.ReactNativeWebView ? "native" : "")
      }
    >
      {isRunningInWebView && window.ReactNativeWebView && (
        <div
          className="start-page__return-home"
          onClick={() => returnHomeNative()}
        >
          <BiArrowBack
            size={"22px"}
            color={"#000"}
            style={iconStyle("transparent")}
          />
          {/* <span>Επιστροφή στην αρχική</span> */}
        </div>
      )}
      {showTerms || showProtection ? (
        <div className="terms-modal">
          <div
            onClick={() => {
              setShowTerms(false);
              setShowProtection(false);
            }}
            className="modal-background show"
          ></div>
          <div className="wrapper">
            <div
              className="wrapper__close"
              onCLick={() => {
                setShowProtection(false);
                setShowTerms(false);
              }}
            >
              <BiX
                size={"30px"}
                color={"#ccc"}
                style={iconStyle("transparent")}
              />
            </div>
            <TermsAndConditions termsOpen={showTerms} />
          </div>
        </div>
      ) : (
        ""
      )}
      <div className="start-page__form">
        <div className="start-page__form-header">
          <img src={logoLink} alt="school-logo" />
        </div>
        {hasRegister ? (
          <div className="toggle">
            <span
              className={"toggle__option " + (isRegister ? "" : "active")}
              onClick={() => setIsRegister(false)}
            >
              Είσοδος
            </span>
            {!window.location.hostname.includes("andriopoulou") ? (
              <span
                className={"toggle__option " + (isRegister ? "active" : "")}
                onClick={() => setIsRegister(true)}
              >
                Εγγραφή
              </span>
            ) : (
              ""
            )}
          </div>
        ) : (
          ""
        )}
        <div
          className={
            "slide-container " +
            (openForgot ? " for-forgot " : " ") +
            (isRegister ? "for-register" : "for-login") +
            (showSuccess ? " success " : "") +
            (errorMsg ? " error " : "")
          }
        >
          <div
            className={
              "forgot-container " +
              (openForgot && !isRegister ? " show " : "close")
            }
          >
            <form onSubmit={(e) => login(e)}>
              <div className="login-input">
                <BiUser
                  size={"30px"}
                  color={"#fff"}
                  style={iconStyle("transparent")}
                />
                <input type="submit" className="d-none " />
                <input
                  type="text"
                  placeholder="Email / Username"
                  value={forgotEmail}
                  onChange={(e) => setForgotEmail(e.target.value)}
                />
              </div>
              <div
                className="login-forgot"
                onClick={() => setOpenForgot(false)}
              >
                <span>Σύνδεση</span>
              </div>
            </form>
            <div className="errors">
              <span>{errorMsg}</span>
            </div>
            <div className="actions">
              <button className="cta cta-fill" onClick={() => forgotPassword()}>
                Αποστολή
              </button>
            </div>
            {showSuccess ? (
              <div className="success">
                <BiCheck
                  size={"30px"}
                  color={"#25e662"}
                  style={iconStyle("transparent")}
                />
                <span>
                  Επιτυχής εγγραφή! Παρακαλώ αναμείνετε μέχρι να ενεργοποιηθεί ο
                  λογαριασμός σας.
                </span>
              </div>
            ) : (
              ""
            )}
          </div>
          <div
            className={
              "login-container " +
              (isRegister ? "close" : "show") +
              (openForgot ? " slide-right " : "")
            }
          >
            <form onSubmit={(e) => login(e)}>
              <div className="login-input">
                <BiUser
                  size={"30px"}
                  color={"#fff"}
                  style={iconStyle("transparent")}
                />
                <input type="submit" className="d-none " />
                <input
                  type="text"
                  placeholder="Email / Username"
                  value={loginEmail}
                  onChange={(e) => setLoginEmail(e.target.value)}
                />
              </div>
              <div className="login-input">
                <BiLockAlt
                  size={"30px"}
                  color={"#fff"}
                  style={iconStyle("transparent")}
                />
                <input
                  type="password"
                  placeholder="Κωδικός"
                  value={loginPwd}
                  onChange={(e) => setLoginPwd(e.target.value)}
                />
              </div>
              <div className="login-forgot" onClick={() => setOpenForgot(true)}>
                <span>Ξέχασες τον κωδικό σου;</span>
              </div>
            </form>
            <div className="errors">
              <span>{errorMsg}</span>
            </div>
            <div className="actions">
              <div className="apple__button" onClick={handleApplePress}>
                <span className="label">Σύνδεση με Apple</span>
                <FaApple className="apple-icon" />
                {isRunningInWebView() && window.ReactNativeWebView ? (
                  "" // native path uses the bridge
                ) : (
                  <div className="apple-provider">
                    <AppleAuth
                      appleLoginFunction={appleLogin}
                      clientId="gr.paliaflorina.web"
                      redirectURI="https://paliaflorina.gr/auth/apple/callback"
                    />
                  </div>
                )}
              </div>
              <div
                className="google__button"
                onClick={() => handleGooglePress()}
              >
                <span className="label">Σύνδεση με Google</span>
                <img
                  className="google-img"
                  src={"logo-google.svg"}
                  alt="edupal-logo"
                />
                {isRunningInWebView && window.ReactNativeWebView ? (
                  ""
                ) : (
                  <div className="google-provider">
                    <GoogleAuth googleLoginFunction={googleLogin} />
                  </div>
                )}
              </div>
              <button className="cta cta-fill" onClick={() => login()}>
                Σύνδεση
              </button>
            </div>
            {showSuccess ? (
              <div className="success">
                <BiCheck
                  size={"30px"}
                  color={"#25e662"}
                  style={iconStyle("transparent")}
                />
                <span>
                  Επιτυχής εγγραφή! Παρακαλώ αναμείνετε μέχρι να ενεργοποιηθεί ο
                  λογαριασμός σας.
                </span>
              </div>
            ) : (
              ""
            )}
          </div>
          <form
            onSubmit={(e) => registerFiles(e)}
            className={
              "register-container no-scrollbar " +
              (isRegister ? "show" : "close")
            }
          >
            <div className="dual-input">
              <div className="login-input">
                <BiUser
                  size={"30px"}
                  color={"#fff"}
                  style={iconStyle("transparent")}
                />
                <input
                  type="text"
                  placeholder="Όνομα"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                />
              </div>
              <div className="login-input">
                <BiUser
                  size={"30px"}
                  color={"#fff"}
                  style={iconStyle("transparent")}
                />
                <input
                  type="text"
                  placeholder="Επίθετο"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                />
              </div>
            </div>
            <div className="login-input">
              <BiMailSend
                size={"30px"}
                color={"#fff"}
                style={iconStyle("transparent")}
              />
              <input
                type="text"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="dual-input">
              <div className="login-input">
                <BiLockAlt
                  size={"30px"}
                  color={"#fff"}
                  style={iconStyle("transparent")}
                />
                <input
                  type="password"
                  placeholder="Κωδικός"
                  value={pwd}
                  onChange={(e) => setPwd(e.target.value)}
                />
              </div>
              <div className="login-input">
                <BiLockAlt
                  size={"30px"}
                  color={"#fff"}
                  style={iconStyle("transparent")}
                />
                <input
                  type="password"
                  placeholder="Επιβεβαίωση κωδικού"
                  value={repeatPwd}
                  onChange={(e) => setRepeatPwd(e.target.value)}
                />
                <input
                  className="d-none"
                  type="submit"
                  value={repeatPwd}
                  onChange={(e) => setRepeatPwd(e.target.value)}
                  placeholder="Επιβεβαίωση κωδικού"
                />
              </div>
            </div>
            <div className="login-input">
              <BiPhone
                size={"30px"}
                color={"#fff"}
                style={iconStyle("transparent")}
              />
              <input
                type="number"
                placeholder="6945454545"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
            </div>
            <div className="start-page-upload">
              <div className="upload-text">
                <span className="label">Γενικές Σημειώσεις</span>
                <textarea
                  value={answerText}
                  onChange={(e) => setAnswerText(e.target.value)}
                  placeholder="Εισάγετε τις σημείωσεις σας εδώ..."
                ></textarea>
              </div>
              <div className="upload-files">
                <span className="label">Αρχεία</span>
                <div className="upload-files__button">
                  <BiUpload
                    size={"60px"}
                    color={"#ccc"}
                    style={iconStyle("transparent")}
                  />
                  {hasCameraAccess !== 0 && (
                    <input
                      className="upload-files__button-input"
                      type="file"
                      accept=".pdf, .jpeg, .jpg, .png"
                      name="myImage"
                      onChange={imageChange}
                      multiple
                    />
                  )}
                </div>
                {!hasCameraAccess && (
                  <span className="upload-files__error">
                    Ενεργοποιήστε τα δικαιώματα κάμερας για να έχετε πρόσβαση
                    στην κάμερα και στα αρχεία σας
                  </span>
                )}
                <div className="upload-files__thumbnails">
                  {populateThumbnails()}
                </div>
              </div>
            </div>
            <div className="errors">
              <span>{errorMsg}</span>
            </div>
            <div className="register-container__terms">
              <div className="target__select">
                <div className="item">
                  <div
                    className={
                      "target__select-radio " + (acceptTerms ? "active" : "")
                    }
                    onClick={() => setAcceptTerms(!acceptTerms)}
                  ></div>
                  <span className="label">
                    Αποδέχομαι τους
                    <span onClick={() => setShowTerms(true)}>
                      όρους χρήσης{" "}
                    </span>
                    και
                    <span onClick={() => setShowProtection(true)}>
                      πολιτικής προστασίας
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div className="actions">
              <div
                className="google__button"
                onClick={() => handleGooglePress()}
              >
                <span className="label">Εγγραφή με Google</span>
                <img
                  className="google-img"
                  src={"logo-google.svg"}
                  alt="edupal-logo"
                />
                {isRunningInWebView && window.ReactNativeWebView ? (
                  ""
                ) : (
                  <div className="google-provider">
                    <GoogleAuth googleLoginFunction={googleLogin} />
                  </div>
                )}
              </div>
              <button className="cta cta-fill">Εγγραφή</button>
            </div>
          </form>
        </div>
      </div>
      {/* <div className="start-page__graphic">
        <div className={"edupal-logo " + (isLoading ? "loading" : "")}>
          {window.location.hostname.includes("lingopowers") ? (
            <img
              className="white-label small"
              src={"lingopowers.png"}
              alt="lingopowers-logo"
            />
          ) : (
            <img src={"logo_white.png"} alt="edupal-logo" />
          )}
        </div>
        <div
          className={
            "circle third " +
            (window.location.hostname.includes("lingopowers")
              ? " purple "
              : "") +
            +(isLoading ? "loading" : "")
          }
        ></div>
        <div
          className={
            "circle second " +
            (isLoading ? "loading" : "") +
            (window.location.hostname.includes("lingopowers") ? " blue" : "")
          }
        ></div>
        <div
          className={
            "circle fourth " +
            (window.location.hostname.includes("lingopowers")
              ? " orange"
              : "") +
            (isLoading ? "loading" : "")
          }
        ></div>
        <div
          className={
            "circle first " +
            (isLoading ? "loading" : "") +
            (window.location.hostname.includes("lingopowers") ? " orange" : "")
          }
        ></div>
      </div> */}
    </div>
  );
};

export default Login;
